import { type Address, type Nullable } from '~/common/types';

import { EMPTY_STRING_FALLBACK } from '~/common/constants';
import getFormattedAddress from './address';

export type DuplicateCase = Partial<Address> & {
  id: string;
  reference?: Nullable<string>;
};

/**
 * Formats a duplicate case as a single "reference (address)" line.
 *
 * @param duplicateCase - Case to format.
 * @returns The formatted line.
 */
export const getDuplicateCaseLine = (duplicateCase: DuplicateCase) =>
  `${duplicateCase.reference || EMPTY_STRING_FALLBACK} (${getFormattedAddress(duplicateCase)})`;
